import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router'

// Constants
import { AddressVerificationWrapper as AddressVerificationSection } from 'views/layouts'

// Assets
import OspreeLogoIcon from 'assets/images/ospreeLogo'

// Hooks
import { useGetAddressVerification } from 'core/hooks/api'

// Components
import { LoaderCircle } from 'views/components'

// Styled Elements
import {
  AddressVerificationWrapper,
  AddressVerificationInnerWrapper,
  AddressVerificationLogoLink,
  AddressVerificationTitle,
  AddressVerificationText,
  AddressVerificationFormContent,
  SuccessWrapper,
  ErrWrapper,
  LoadingWrapper,
} from './AddressVerification.elements'

function AddressVerification() {
  // Local State
  const [addressVerificationDetails, setAddressVerificationDetails] = useState()
  const [successMsg, setSuccessMsg] = useState()
  const [errMsg, setErrMsg] = useState()

  // Hooks
  const { cipher_text } = useParams()
  const {
    getAddressVerification,
    getAddressVerificationData,
    getAddressVerificationError,
    isGetAddressVerificationLoading,
  } = useGetAddressVerification()

  // UseEffects
  useEffect(() => {
    getAddressVerification({ cipher_text })
  }, [])
  useEffect(() => {
    if (getAddressVerificationData) setAddressVerificationDetails(getAddressVerificationData)
  }, [getAddressVerificationData])
  return (
    <AddressVerificationWrapper>
      <AddressVerificationInnerWrapper>
        {isGetAddressVerificationLoading && (
          <LoadingWrapper>
            <LoaderCircle />
          </LoadingWrapper>
        )}
        {successMsg && (
          <AddressVerificationFormContent>
            <SuccessWrapper>
              <AddressVerificationTitle>Successfully validated wallet!</AddressVerificationTitle>
              <AddressVerificationText>
                Successfully validated the ownership of the wallet. You may now close this window.
              </AddressVerificationText>
            </SuccessWrapper>

            <AddressVerificationLogoLink target="_blank" href="https://www.ospree.io/">
              <AddressVerificationText>Powered by:</AddressVerificationText>
              <OspreeLogoIcon />
            </AddressVerificationLogoLink>
          </AddressVerificationFormContent>
        )}
        {errMsg && (
          <AddressVerificationFormContent>
            <ErrWrapper>
              <AddressVerificationTitle>Invalid signature</AddressVerificationTitle>
              <AddressVerificationText>{errMsg}</AddressVerificationText>
            </ErrWrapper>

            <AddressVerificationLogoLink target="_blank" href="https://www.ospree.io/">
              <AddressVerificationText>Powered by:</AddressVerificationText>
              <OspreeLogoIcon />
            </AddressVerificationLogoLink>
          </AddressVerificationFormContent>
        )}
        {!isGetAddressVerificationLoading && addressVerificationDetails && !successMsg && !errMsg && (
          <AddressVerificationFormContent>
            <AddressVerificationTitle>Wallet Ownership Verification</AddressVerificationTitle>
            <AddressVerificationText>
              To comply with FATF Travel Rule Requirements, we need to verify that you own the destination wallet.
            </AddressVerificationText>
            <AddressVerificationSection
              addressVerificationDetails={addressVerificationDetails}
              cipherText={cipher_text}
              setSuccessMsg={setSuccessMsg}
              setErrMsg={setErrMsg}
            />
            <AddressVerificationLogoLink target="_blank" href="https://www.ospree.io/">
              <AddressVerificationText>Powered by:</AddressVerificationText>
              <OspreeLogoIcon />
            </AddressVerificationLogoLink>
          </AddressVerificationFormContent>
        )}
        {!isGetAddressVerificationLoading && getAddressVerificationError && (
          <AddressVerificationFormContent>
            <AddressVerificationText>Link has expired or is invalid</AddressVerificationText>
          </AddressVerificationFormContent>
        )}
      </AddressVerificationInnerWrapper>
    </AddressVerificationWrapper>
  )
}

// Default Props
AddressVerification.defaultProps = {}

// Proptypes Validation
AddressVerification.propTypes = {}

export default AddressVerification
